module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_b1-8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/t008-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_b1-8"
    }
  }), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    attrs: {
      "id": "page_b1-8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_intro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Partly Dave")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Flies on Frank")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Dog Nigel")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Denis")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fat Growth on Eric Hearble")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wrestling Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Randolf’s Party")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Famous Five through Woenow Abbey")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sad Michael")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Wandered")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene three Act one")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treasure Ivan")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Abord Speeching")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fingletoad Resort of Teddiviscious")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alec Speaking")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    attrs: {
      "id": "page_b1-9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liddypool")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Might Well Arsk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nicely Nicely Clive")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neville Club")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moldy Moldy Man")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*On Safairy with Whide Hunter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Sat Belonely")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry and Harry")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deaf Ted, Danoota, (and me)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Suprise for Little Bobby")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Halbut Returb")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unhappy Frank")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On this Churly Morn")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victor Triumphs Again and Mrs. Weatherby Learns a Lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/b1_ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Remember Arnold")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_vm._v("*Written in conjugal with Paul.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_b1-10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_b1-10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94eb31ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/b1_content.vue
// module id = 78
// module chunks = 0